// Copyright 2021 andrewzeck
// 
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
// 
//     http://www.apache.org/licenses/LICENSE-2.0
// 
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
import React, { useCallback, useEffect, useState } from "react";
import Table from "../../components/Table/Table";
import styles from "assets/jss/material-dashboard-pro-react/components/tableStyle";
import _ from "lodash";

import { makeStyles, withStyles } from "@material-ui/core/styles";
import RegularButton from '../../components/CustomButtons/Button';
import Overlay from "../../components/Overlay/Overlay";
import { BsThreeDots } from "react-icons/all";
import Popper from "@material-ui/core/Popper";
import Grow from "@material-ui/core/Grow";
import Paper from "@material-ui/core/Paper";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import MenuList from "@material-ui/core/MenuList";
import MenuItem from "@material-ui/core/MenuItem";
import { connect } from "react-redux";
import { SmallUppercase } from "../../text";
import GridContainer from "../../components/Grid/GridContainer";
import GridItem from "../../components/Grid/GridItem";
import CustomInput from "../../components/CustomInput/CustomInput";
import Check from "@material-ui/icons/Check";
import Checkbox from "@material-ui/core/Checkbox";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import { createRetailerFTPCredentials, updateRetailerFTPConfig, getSellersForConfig, getInventoryOutputFolders} from "../../api";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton
} from "@material-ui/core";

class SellerFTPDialog extends React.Component {
  state = {
    error:null,
    loading:false,
    output_paths:[]
  }
  _loadPaths(){
    this.setState({ loading: true }, () => {
      getInventoryOutputFolders().then((results)=>{
        if(results && results.data && results.data.length){
          console.log(`received ${results.data.length}`)
          let paths = _.map(results.data, 'Prefix');
          this.setState({ output_paths: paths, loading: false });
        }
        else {
          this.setState({loading:false})
        }
      })
    });
  }
  componentDidMount = () =>{
    this._loadPaths();
  }
  onPathClick = (e, idx) => {
    let value = e.target.value;
    console.log(value);
    this.props.seller.import_settings.credentials.processed_output_path = value;
    this.setState({ loading: false });
  }
  submit = () => {
    const {
      seller
    } = this.props;
    this.setState({loading: true}, () => {
      updateRetailerFTPConfig(seller.store_id, seller.import_settings).then( () => {
        this.setState({loading:false})
        this.props.closeFTPDialog(true)
      }).catch( () => {
        //axios middleware is gonna throw error popup already
        this.setState({loading:false})
      })
    });
  };
  renderObjectSettings = (seller, settingsObj, parentKey = '') => {
    return Object.keys(settingsObj).map((key) => {
      const value = settingsObj[key];
      const fullKey = parentKey ? `${parentKey}.${key}` : key;
  
      if (_.isString(value)) {
        return (
          <CustomInput
            labelText={fullKey}
            inputProps={{
              value: value,
              onChange: (e) => {
                _.set(seller.import_settings, fullKey, e.currentTarget.value);
                this.setState({ seller });
              },
            }}
          />
        );
      } else if (_.isBoolean(value)) {
        return (
          <Checkbox
            checked={value}
            onClick={() => {
              const newValue = !value;
              _.set(seller.import_settings, fullKey, newValue);
              this.setState({ seller });
            }}
            checkedIcon={<Check className={classes.checkedIcon} />}
            icon={<Check className={classes.uncheckedIcon} />}
            classes={{
              checked: classes.checked,
              root: classes.checkRoot,
            }}
          />
        );
      } else if (_.isNumber(value)) {
        return (
          <CustomInput
            labelText={fullKey}
            inputProps={{
              value: value,
              type: 'number',
              onChange: (e) => {
                _.set(seller.import_settings, fullKey, parseFloat(e.currentTarget.value));
                this.setState({ seller });
              },
            }}
          />
        );
      } else if (_.isObject(value)) {
        return renderObjectSettings(value, fullKey);
      }
      return null;
    });
  };
  render(){
    let { loading, error } = this.state;
    let { seller, editConnection, classes } = this.props;
    let creds = seller.import_settings.credentials;
    let connectionType = editConnection ? "Read External FTP" : "Push to Saucey FTP"
    let settings = {
      sku:'',
      price:'',
      quantity:'',
      upc:'',
      discontinued:'',
      quantity_threshold:1,
      title:'',
      last_sold:'',
      category:'',
      sync_upc:true,
      disable_unmatched:true,
      default_cooldown:{
        days:0,
        hours:0,
        minutes:0
      }
    }
    let outputPath = creds.processed_output_path;
    let rows = [];

    for(let key in settings){
      let value = settings[key];
      if(_.has(seller, `import_settings.${key}`)){
        value = seller.import_settings[key];
      }
      if(_.isString(value)){
        rows.push(
          <CustomInput
            labelText={key}
            inputProps={{
              value: value,
              onChange: (e) => {
                seller.import_settings[key] = e.currentTarget.value;
                console.log('update prop:', key)
                this.setState({ seller });
              },
            }}
          />
        )
      }
      else if(_.isBoolean(value)){
        console.log("initial value:", key, value)
        rows.push(
          <Checkbox
          checked={value}
          onClick={(e) => {
            value = !value;
            seller.import_settings[key] = value;
            console.log(key, value);
            this.setState({ seller });
          }}
          checkedIcon={<Check className={classes.checkedIcon} />}
          icon={<Check className={classes.uncheckedIcon} />}
          classes={{
            checked: classes.checked,
            root: classes.checkRoot,
          }}
          />
        )
      }
      else if(_.isNumber(value)){
        rows.push(
          <CustomInput
            labelText={key}
            inputProps={{
              value: value,
              type:"number",
              onChange: (e) => {
                seller.import_settings[key] = e.currentTarget.value;
                this.setState({ seller });
              },
            }}
          />)
      } else if (_.isObject(value) && !_.isArray(value)) {
        rows = rows.concat(this.renderObjectSettings(seller, value, key));
      }
    }
    let pathOptions = this.state.output_paths;

    return (
      <Dialog open={true} maxWidth="lg" fullWidth>
        {loading && <Overlay type="loading" />}
        {error && (
          <Overlay
            type="error"
            message={error}
            dismiss={
              <RegularButton
                size="sm"
                color="primary"
                onClick={() => {
                  this.setState({ error: null });
                }}
              >
                Dismiss
              </RegularButton>
            }
          />
        )}
        <div>
          <DialogTitle>{seller.store_id} - {seller.name}</DialogTitle>
          <h3>FTP Configuration - {connectionType}</h3>
        </div>
        <GridItem xs={12}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={3}>
              <CustomInput
                formControlProps={{
                  fullWidth: true,
                }}
                labelText="Host"
                inputProps={{
                  disabled: !editConnection,
                  value: creds.host,
                  onChange: (e) => {
                    seller.import_settings.credentials.host = e.currentTarget.value;
                    this.setState({ seller });
                  },
                }}
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={3}>
              <CustomInput
                formControlProps={{
                  fullWidth: true,
                }}
                labelText="User"
                inputProps={{
                  disabled: !editConnection,
                  value: creds.user,
                  onChange: (e) => {
                    seller.import_settings.credentials.user = e.currentTarget.value;
                    this.setState({ seller });
                  },
                }}
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={3}>
              <CustomInput
                formControlProps={{
                  fullWidth: true,
                }}
                fullWidth
                labelText="Password"
                inputProps={{
                  disabled: !editConnection,
                  value: creds.password,
                  onChange: (e) => {
                    seller.import_settings.credentials.password = e.currentTarget.value;
                    this.setState({ email: e.currentTarget.value });
                  },
                }}
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={3}>
              <CustomInput
                formControlProps={{
                  fullWidth: true,
                }}
                fullWidth
                labelText="Path"
                inputProps={{
                  disabled: !editConnection,
                  value: creds.path,
                  onChange: (e) => {
                    seller.import_settings.credentials.path = e.currentTarget.value;
                    this.setState({ seller });
                  },
                }}
              />
            </GridItem>
          </GridContainer>
        </GridItem>
        <div>
            <Table
              striped
              tableHead={[
                "Retailer SKU",
                "Price",
                "Quantity",
                "UPC",
                "Disabled",
                "Quantity Threshold",
                "Product Name",
                "Last Sold",
                "Category",
                "Sync UPC",
                "Disable Unmatched Items",
                "Inventory Cooldown Days",
                "Inventory Cooldown Hours",
                "Inventory Cooldown Minutes",
              ]}
              hits={[]}
              tableData={[rows]}
              customHeadCellClasses={[classes.noPadding]}
            />
        </div>
        <InputLabel
          htmlFor="select"
          className={classes.selectLabel}
        >
          {"Processed Output Path Location"}
        </InputLabel>
        <div>
        <Select
          multiple={false}
          value={outputPath !== undefined ? outputPath : ""}
          onChange={(e) => this.onPathClick(e)}
          MenuProps={{ className: classes.selectMenu }}
          classes={{ select: classes.select }}
          inputProps={{
            name: "multipleSelect",
          }}
        >
          {pathOptions.map((option, i) => {
          return <MenuItem
            key={`output_path_${i}`}
            classes={{
              root: classes.selectMenuItem,
              selected: classes.selectMenuItemSelectedMultiple,
            }}
            value={option}
          >
            {option}
          </MenuItem>
        })}
        </Select>
        {outputPath && <IconButton
          onClick={() => {
            this.props.seller.import_settings.credentials.processed_output_path = undefined;
            this.setState({loading:false})
          }}
        >
          <RemoveCircleIcon style={{ color: "red" }} />
        </IconButton>}
        </div>
        <GridContainer>
            <GridItem xs={12} style={{ textAlign: "right" }}>
              <RegularButton
                className={this.props.classes.saveButton}
                color="danger"
                size="sm"
                onClick={this.props.closeFTPDialog}
              >
                <SmallUppercase light>Cancel</SmallUppercase>
              </RegularButton>
              <RegularButton
                className={this.props.classes.saveButton}
                color="info"
                size="sm"
                onClick={this.submit}
              >
                <SmallUppercase light>Save</SmallUppercase>
              </RegularButton>
            </GridItem>
        </GridContainer>
      </Dialog>
    )
  }
}
export default connect((state) => ({
  stores: state.app.stores,
  user: state.app.user,
}))(withStyles(styles)(SellerFTPDialog));